module.exports = __webpack_public_path__ + "img/icon42.512db650.png";